import { createSelector } from 'reselect';

import getElectDecoratedConsumptionDataSelector from './getElectDecoratedConsumptionDataSelector';
import type { RootState } from '/business/shared/state/store';

const getCertId = (_state: RootState, certId: number | undefined) => certId;

export default createSelector([getElectDecoratedConsumptionDataSelector, getCertId], (consumptionData, certId) => {
  if (!certId) {
    return 0;
  }
  const locationsWithCert = consumptionData.filter((consumption) => {
    return consumption.certificates?.some((cert) => cert.certificate_id === certId);
  });
  const uniqueLocationIds = new Set(locationsWithCert.map((location) => location.location_id));
  return uniqueLocationIds.size;
});
